<ng-container *transloco="let t;">
  <div class="shared-vehicles-filter material-radio-button">
    <mat-radio-group
      [value]="selectedValue()"
      class="shared-vehicles-radio-group"
    >
      <!-- All Recipients Radio Button -->
      <div class="filter-option mb-2">
        <mat-radio-button
          class="_mat-animation-noopable"
          [value]="'all'"
          [disableRipple]="true"
          (change)="selectAllRecipients()"
          [aria-label]="t('sellModule.manageInventory.searchFilter.labelAllRecipients')"
          data-test-id="app-shared-vehicles-filter-all-recipients"
        >
          {{ t('sellModule.manageInventory.searchFilter.labelAllRecipients') }}
        </mat-radio-button>
      </div>

    <!-- Account Managers -->
    @for (accountManager of accountManagersForOfferLists; track accountManager.value) {
      <div class="account-manager-section mb-2 ms-2">
        <!-- Account Manager Label -->
        <label class="account-manager-label fw-bold d-block mb-2">
          {{ accountManager.name }}
        </label>

        <!-- All Lists Radio Button for Account Manager -->
        <div class="filter-option mb-2 ms-1">
          <mat-radio-button
            class="_mat-animation-noopable"
            [value]="'accountManager:' + accountManager.value"
            [disableRipple]="true"
            (change)="selectAccountManagerAllLists(accountManager.value)"
            [aria-label]="t('sellModule.manageInventory.searchFilter.labelAllList') + ' - ' + accountManager.name"
            [attr.data-test-id]="'app-shared-vehicles-filter-am-all-lists-' + accountManager.value"
          >
            {{ t('sellModule.manageInventory.searchFilter.labelAllList') }}
          </mat-radio-button>
        </div>

        <!-- Buying Dealers Dropdowns -->
        @for (dealer of getVisibleDealers(accountManager.value, accountManager.buyerOeUuid); track dealer.value) {
          <div class="dealer-section ms-2">
            <app-search-filter-section
              [title]="dealer.name"
              variant="link"
              [scrollable]="false"
              [analyticsName]="'Buying Dealer (accordion)'"
              [open]="isDealerDropdownOpen(accountManager.value, dealer.value)"
              (openChange)="toggleDealerDropdown(accountManager.value, dealer.value)"
            >
              <div class="dealer-content ms-3">
                <!-- Shared List Recipients as Labels -->
                @for (sharedListRecipient of dealer.userNameUuid; track sharedListRecipient.value) {
                  <div class="shared-list-recipient-section mb-2">
                    <!-- Recipient Label -->
                    <label class="shared-list-recipient-label fw-bold d-block mb-1">
                      {{ sharedListRecipient.name }}
                    </label>

                    <!-- All Lists Radio Button for Recipient (only show if more than 1 offer list) -->
                    @if (sharedListRecipient.offerListUuid?.length > 1) {
                      <div class="filter-option mb-1 ms-2">
                        <mat-radio-button
                          class="_mat-animation-noopable"
                          [value]="'recipient:' + accountManager.value + ':' + dealer.value + ':' + sharedListRecipient.value"
                          [disableRipple]="true"
                          (change)="selectRecipientAllLists(accountManager.value, dealer.value, sharedListRecipient.value)"
                          [aria-label]="t('sellModule.manageInventory.searchFilter.labelAllList') + ' - ' + sharedListRecipient.name"
                          [attr.data-test-id]="'app-shared-vehicles-filter-recipient-all-lists-' + sharedListRecipient.value"
                        >
                          {{ t('sellModule.manageInventory.searchFilter.labelAllList') }}
                        </mat-radio-button>
                      </div>
                    }

                    <!-- Offer List Radio Buttons -->
                    @for (offerList of sharedListRecipient.offerListUuid; track offerList.value) {
                      <div class="filter-option mb-1 ms-2">
                        <mat-radio-button
                          class="_mat-animation-noopable"
                          [value]="'offerList:' + offerList.value"
                          [disableRipple]="true"
                          (change)="selectOfferList(offerList.value)"
                          [aria-label]="offerList.name"
                          [attr.data-test-id]="'app-shared-vehicles-filter-offer-list-' + offerList.value"
                        >
                          {{ offerList.name }}
                        </mat-radio-button>
                      </div>
                    }
                  </div>
                }
              </div>
            </app-search-filter-section>
          </div>
        }

        <!-- Show More / Show Less Button -->
        @if (shouldShowDealerToggleButton(accountManager.value, accountManager.buyerOeUuid)) {
          @if (hasMoreDealers(accountManager.value, accountManager.buyerOeUuid)) {
            <button
              type="button"
              class="btn btn-link p-0 mt-2 ms-2 show-more-btn"
              (click)="showMoreDealers($event, accountManager.value)"
              [attr.data-test-id]="'app-shared-vehicles-dealer-show-more-btn-' + accountManager.value">
              {{ t('common.btnShowMore') }}
            </button>
          } @else if (canShowLessDealers(accountManager.value, accountManager.buyerOeUuid)) {
            <button
              type="button"
              class="btn btn-link p-0 mt-2 ms-2 show-less-btn"
              (click)="showLessDealers($event, accountManager.value)"
              [attr.data-test-id]="'app-shared-vehicles-dealer-show-less-btn-' + accountManager.value">
              {{ t('common.btnShowLess') }}
            </button>
          }
        }
      </div>
    }
    </mat-radio-group>
  </div>
</ng-container>
